import { useState } from 'react'
import FooterPartenerCommun from '../commun/FooterPartenerCommun'
import Header from '../commun/Header'

export default function Program(){

    const dates = [
        'Friday 15',
        'Saturday 16',
        'Sunday 17',
    ];

    const [day, setDay] = useState(0);

    const program = [
        [
            {
                hours: `09:30 – 17:00`,
                program: {
                    title: 'David Rockefeller Fellows (DRF)Day Program',
                    description: '(organized by DRFs)',
                    moderators:[

                    ],
                    speakers:[
                        
                    ],
                },
                room: `Level 1 - Empire`,
            },
            {
                hours: `17:00 – 18:30`,
                program: {
                    title: 'Executive Committee Meeting',
                    description: '(for ExCom Members only; at the <a href="https://maps.app.goo.gl/UWNpkZ7G6LVXVsk4A">Rosewood Magna Hotel</a>',
                    moderators:[

                    ],
                    speakers:[
                        
                    ]
                },
                room: `Library, Foyer & Café Wiltcher`,
            },
            {
                hours: `18:30`,
                program: {
                    title: '<span style="font-weight: normal">Meet in the Main Hall of the Rosewood Villa Magna Hotel</span>',
                    description: `<span style="font-weight: bold">departure by bus to
                                    the Museo Nacional del Prado</span>`,
                    moderators:[

                    ],
                    speakers:[
                        
                    ]
                },
                room: `Groundfloor - Ballroom`,
            },
            {
                hours: `19:00 – 20:30`,
                program: {
                    title: `Official Opening and Welcome Reception (at the <a href="https://maps.app.goo.gl/2PgWJSfzBHNGfq65A">Museo Nacionaldel Prado</a>) Welcome Remarks by Javier Solana`,
                    description: `Chairman of Museo del Prado, former
                                    NATO Secretary General and EU High Representative for Common Foreign
                                    and Security Policy`,
                    moderators:[

                    ],
                    speakers:[
                        new Speaker('Luis de Carlos', 'Chairman of the Spanish Group'),
                        new Speaker('Axel A. Weber', 'European Chairman of the Trilateral Commission'),
                        new Speaker('José Luis Martínez Almeida', 'Mayor of Madrid'),
                    ]
                },
                room: `Groundfloor  - Ballroom`,
            },
            {
                hours: `20:30`,
                program: {
                    title: '<span style="font-weight: normal">Depart for </span>National Groups’ Dinners with their Ambassadors',
                    description: '',
                },
                room: `Groundfloor - Ballroom`,
            },
        ],
        [
            {
                hours: '08:30 – 09:15',
                program:{
                    title: `Formal Opening by the Conference Chairmen with a Welcome Speech by`,
                    description: ``,
                    moderators:[

                    ],
                    speakers:[
                        new Speaker('Carlos Cuerpo', 'Spanish Minister of Economy, Trade and Business'),
                        new Speaker('Luis de Carlos', 'Chairman of the Spanish Group'),
                        new Speaker('Axel A. Weber', 'European Chairman of the Trilateral Commission'),
                    ],
                },
                room: 'Level 1 - Empire, Level 1 - Bellevue, Level 1 - Belvédère',
            },
            {
                hours: '09:15 – 09:45',
                program:{
                    title: `Talk 1: Boosting European Competitiveness – Spurring Growth With a New Industrial Deal and Investments `,
                    description: `a Conversation
                                    Between
                                    <span style="font-weight: bold">
                                    Solveigh
                                    Hieronimus
                                    </span>
                                    , Senior Partner, McKinsey & Company, Inc.,
                                    and <span style="font-weight: bold">Julia Reuss</span>
                                    ,
                                    Director Public Policy Central Europe, Meta
                                    Europe has benefited from its openness to trade and its limits on st
                                    ate aid
                                    support to foster competition and enforce anti
                                    -
                                    trust rules. But other players,
                                    above all the United States, have raised tariffs and engaged in more proactive
                                    industrial policy (U.S. Inflation Reduction Act). Europe has also taken some
                                    policy measur
                                    es, such as the 2021 Recovery and Resilience Facility, followed by
                                    the Green Deal Industrial Plan, and the EU Chips Act in 2023. But the global
                                    playing field remains uneven. Many competitive fields have “winner
                                    -
                                    takes
                                    -
                                    most” dynamics, where a few big compani
                                    es dominate the market and earn
                                    most of the profits. To match their U.S. counterparts, Europe's large
                                    corporations would need to grow in size. This would entail merging across
                                    borders (and changing anti
                                    -
                                    trust rules) as well as intensifying European
                                    integra
                                    tion, which implies granting more authority to the EU. How can Europe
                                    update its rules to compete effectively in the future?`,
                },
                room: 'Groundfloor - Ballroom',
            },
            {
                hours: '09:15 – 9:45',
                program: {
                    title: 'Panel 1 : Enhancing Banking and Capital Markets in Europe',
                    description: `
                                    Europe’s lower returns and investment gaps are exposed by the rising cost of
                                    capital. Interest rates have been low for many years, and capital has been
                                    plentiful. But rates have risen when significant capital is required for the green
                                    transition and to sup
                                    port innovation. Yet European capital markets are not as
                                    deep as those in the United States. European companies have less financial
                                    resources, which makes them smaller (in scale) and more vulnerable
                                    to
                                    acquisitions. And finally, economies need to be able t
                                    o nurture the big firms of
                                    the future. While European companies such as Northvolt, Doctolib, and Bolt
                                    have expanded quickly in recent years, Europe currently has only 13 percent of
                                    the world's unicorns (the same as China), while the United States has produ
                                    ced
                                    50 percent. How can Europe boost corporate investment? How can European
                                    leaders start a positive cycle of more business growth and scale, leading to
                                    higher corporate returns and more capital?
                                    `,
                    moderators: [
                        new Moderator('Claudia Parzani', 'Senior Advisor, Linklaters and Chair, Borsa Italiana, Euronext Group')
                    ],
                    speakers: [
                        new Speaker('Jean Lemierre', ' Chairman, BNP Paribas, former President of the European Bank for Reconstruction and Development (EBRD)'),
                        new Speaker('Carlos Torres Vila', 'Chair of Banco Bilbao Vizcaya Argentaria (BBVA)'),
                        new Speaker('osé Manuel Campa', 'Chairman, European Banking Authority, former Secretary of State for Economy in the Government of Spain'),
                        new Speaker('Andreas Treichl', 'President, European Forum, Alpbach; Chairman of the Supervisory Board, Erste Group Foundation, former CEO Erste Group'),
                    ],
                    others: [
                    ]
                },
                room: 'Groundfloor - Ballroom',
            },
            {
                hours: '10:45 – 11:15',
                program:{
                    title: `Coffee Break`,
                    description: ``,
                    moderators:[

                    ],
                    speakers:[
                        
                    ],
                    others:[
                        
                    ],
                },
                room: 'Groundfloor - Corridor & Foyer',
            },
            {
                hours: '11:15 – 12:15',
                program:{
                    title: `Panel 2 : Innovation With Cutting-Edge Technologies`,
                    description: `Europe's traditional industries, including automotive, aerospace, and
                                    pharmaceuticals, are at risk from tech disruptions, as the advantage shifts
                                    towards advanced technologies. Europe trails in areas like AI and quantum
                                    computing, both of which promise tra
                                    nsformative impacts across
                                    many fields
                                    such as
                                    security, energy, and logistics. The pursuit of quantum advancements
                                    and new technologies calls for substantial investments beyond the scope of any
                                    single country, necessitating European and global cooperation
                                    to form durable
                                    quantum sectors and value chains. Questions arise about how Europe can
                                    enhance investment in corporate R&D for AI and related technologies, create
                                    regulations that foster innovation, attract talent, and support tech firms.`,
                    moderators:[
                        new Moderator('Carme Artigas', `Co-Chair AI Advisory Body United Nations; former Spanish Secretary of State for Digitalisation and Artificial Intelligence`),
                        new Moderator('Scene Setter: Jacobo Roa Vicens', `Machine Learning Centre of Excellence,
                                        JPMorgan Chase & Co.; Centre for Computational Stat
                                        istics and Machine
                                        Learning, University College London (and current
                                        <strong>DRF</strong>)`),
                    ],
                    speakers:[
                        new Speaker(`José María Álvarez-Pallete`, 'Chairman & CEO, Telefónica S.A.'),
                        new Speaker('Phaedra Boinoridis', 'IBM Consulting’s Global Lead for Trustworthy AI'),
                        new Speaker('Jeff Bullwinkel', 'VP & Deputy General Counsel, Corporate External & Legal Affairs, Microsoft EMEA'),
                        new Speaker('Martin Weiss', 'Managing Director, Viscal Capital; former Executive Board Member and CEO, Hubert Burda Media Group'),
                    ],
                },
                room: 'Groundfloor - Library, Foyer & Café Wiltcher',
            },
            {
                hours: '12:15 – 12:45',
                program:{
                    title: `Talk 2:
                                Central Banks’
                                Balancing Act`,
                    description: `<strong>A Conversation between
                                    Fiona
                                    Maharg
                                    -
                                    Bravo
                                    </strong>
                                    ,
                                    Partner,
                                    Brunswick Group, and
                                    <strong>Luis de Guindos</strong>
                                    , Vice
                                    -
                                    President, European Central Bank
                                    (ECB)
                                    ,
                                    <strong>
                                    about
                                    the
                                    outlook of the European economy and its banks</strong>
                                    Central banks on both sides of the Atlantic are finally lowering
                                    interest
                                    rates,
                                    but they still
                                    face a challenging balancing act of keeping inflation under control
                                    without hurting the economy.`,
                    moderators:[
                        
                    ],
                    speakers: [],
                    others:[

                    ]
                },
                room: 'Groundfloor - Ballroom)',
            },
            {
                hours: '12:45 – 14:00',
                program:{
                    title: `Lunch Break`,
                    description: ``,
                    moderators:[

                    ],
                    speakers:[

                    ],
                    others:[

                    ]
                },
                room: 'Groundfloor - Ballroom',
            },
            {
                hours: '14:00 – 15:00',
                program:{
                    title: `Panel 3 : Key Priorities for Europe’s Role in the World`,
                    description: `The single market is crucial for the EU's global role amid growing geopolitical
                                    rivalry. The main goals for the next legislative term will be to deal with how to
                                    fund a fair, green and digital transformation of the internal market, the
                                    consistent and order
                                    ly enlargement of the EU and the expansion of European
                                    production capacities of the security and defense industry. Also, the energy,
                                    digital and financial sectors should be aligned
                                    and a
                                    single market for capital
                                    –
                                    a Capital Markets Union
                                    –
                                    created. The
                                    in
                                    ternal European infrastructure
                                    development needs to be accelerated.`,
                    moderators:[
                        new Moderator('Sylvie Kauffmann', 'Editorial Director and Foreign Affairs Columnist, Le Monde; Contributing Writer to the Financial Times')
                    ],
                    speakers:[
                        new Speaker(`Nadia Calviño`, `President of the European Investment Bank, former First Deputy Prime Minister and Minister of Economy of Spain`),
                        new Speaker(`Marek Belka`, `Former Prime Minister of the Republic of Poland`),
                        new Speaker(`Mario Monti`, `Member of the Italian Senate, former Prime Minister of Italy, former Member of the European Commission and TC Honorary European Chairman`)
                    ],
                    others:[
                        new Other('Scene Setter: ', '<strong>Edoardo Campanella</strong>, Research Fellow at the Harvard Kennedy School; <strong>DRF Alumn</strong>'),
                    ]
                },
                room: 'Groundfloor - Corridor & Foyer',
            },
            {
                hours: '15:00 – 16:00',
                program:{
                    title: `Panel 4: After the U.S.-Elections: A Conversation on Security and Trade`,
                    description: `The
                                    late Henry Kissinger
                                    –
                                    the planner of America’s “opening to China” in 1972
                                    –
                                    said in his 100
                                    th
                                    birthday interviews that if the United States and China don’t
                                    find a new way to cooperate strategically, they will keep clashing and may even o to war. Even wi
                                    thout an actual hot war,
                                    a Sino
                                    -
                                    American cold war
                                    –
                                    which
                                    will intensify regardless of the outcome of the U.S. elections
                                    –
                                    means
                                    the global
                                    economy will split into two zones with less integration and more barriers for
                                    goods, services, capital, people, data
                                    , and knowledge. Free trade is replaced by
                                    protectionism and subsidies, as countries focus on security over efficiency.
                                    Global supply chains will become more local and costly, to reduce risk and
                                    increase resilience. Above all, Europe’s traditionally open t
                                    rade patterns are
                                    affected by increasing geopolitical conflicts, leading to more disputes and
                                    forcing companies to restructure supply chains. Europe may need to ensure
                                    that it has a secure and sustainable access to materials that are strategically
                                    importan
                                    t in a potentially more fragmented world. This effort may involve
                                    difficult tradeoffs.`,
                    moderators:[
                        new Moderator('José Maria de Areilza', 'Professor and Jean Monnet Chair, ESADE Business School, Secretary General, Aspen Institute Spain')
                    ],
                    speakers:[
                        new Speaker('Jay Collins', `Vice Chairman of Banking, Capital Markets and Public Sector,
                                                    Citigroup`),
                        new Speaker('Leslie Vinjamuri', 'Director of the U.S. and Ame ricas Programme at Chatham House, and Professor of International Relations at SOAS University of London'),
                        new Speaker('Anthony Gardner', `Managing Partner, Brookfield Private Equity, former U.S. Ambassador to the European Union`),
                    ],
                    others : [
                        new Other('Scene Setter: ', `<strong>Alessandro Piccioni</strong>
                                                    ,
                                                    Operating Director, CVC Capital Partners,
                                                    London; Independent Board Member and RemCo Chair, Trevifin, Milan;
                                                    <strong>DRF</strong>`),
                    ]
                },
                room: 'Groundfloor - Ballroom',
            },
            {
                hours: '16:00 – 16:30',
                program:{
                    title: `Cofee Break`,
                    description: ``,
                    moderators:[
                    ],
                    mores : [
                    ],
                    speakers:[
                    ],
                    others :[
                    ]
                },
                room: 'Groundfloor - Ballroom',
            },
            {
                hours: '16:30 – 17:30',
                program:{
                    title: `Panel 5 : America’s Reorientation and Europe’s “Guns or Butter” Dilemma`,
                    description: `Europe should strive to achieve its own security, particularly in light of China's
                                    emergence as a military competitor to the United States and Washington’s
                                    growing focus on Asia. The Un
                                    ited States will expect its European allies to
                                    increase their defense spending against a resurgent Russia and the rebuilding
                                    of Ukraine, no matter who wins the U.S. elections. In view of the tight budget
                                    situation in many European countries, however, every
                                    euro that would be
                                    saved on social benefits (butter) and invested in armaments (guns) or the
                                    reconstruction of Ukraine would be another vote for those extremist parties
                                    that already benefit from the ballot box because of the inability of policy
                                    -
                                    makers to
                                    solve pressing problems. Would “pooling and sharing” as well as
                                    common debt to strengthen Europe militarily and finance the reconstruction
                                    of Ukraine defuse the “butter versus guns” dilemma?
                                    Is it possible to integrate
                                    the United Kingdom into a shared Euro
                                    pean defense framework?`,
                    moderators:[
                        new Moderator('Manuel Muñiz', `Provost of IE University in Madrid and a Professor
                                                        of Practice of International Relations; former State Secretary at the Spanish
                                                        Foreign Ministry`),
                    ],
                    speakers:[
                        new Speaker(`Amanda Sloat`
                                        ,`Former Special Assistant to the President and Senior Director
                                        for Europe, U.S. National Security Council`),
                        new Speaker(`Ana Palacio`, `Former Minister of Foreign Affairs, Spain; Visiting
                                                        Professor,
                                                        Edmund A. Walsh School of Foreign Service, Georgetown University`),
                        new Speaker(`Sylvie Goulard`, `President of the Deutsch
                                                        -
                                                        Französisches Institut (Ludwigsburg,
                                                        Germany);
                                                        former Deputy Governor of the Banque de France; former Minister
                                                        of the Armed Forces; former
                                                        Member of the European Parliament`),
                        new Speaker(`Alexandra de Hoop Scheffer`, `Acting President of the German Marshall Fund of the United States`),
                    ],
                    others:[
                        new Other('Scene Setter: ', ' <strong<Maciej Kuziemski</strong> CEO of PKO Bank Polski Foundation and Co - Founder of Philanthropy for Impact'),
                    ]
                },
                room: '3, rue de la Régence - 1000 Brussels',
            },
            {
                hours: '17:30 – 18:30',
                program:{
                    title: `Panel 6: Energy Policy, Competition, and Diversification for Europe’s Transformation`,
                    description: `European industry relied on cheap energy, but its vulnerability to import
disruptions was exposed when Russia invaded Ukraine and cut off gas supplies.
Industrial power and gas prices went up twofold between the first and second
half of 202
0
-
2022 as Europe tried to replace Russian gas with efficiency and
liquefied natural gas. At the same time, Europe needs cheap and plentiful
energy to keep its industries that use a lot of energy (such as farming,
chemicals, or steel) competitive with other
regions. Moreover, realizing
Europe’s ambitious climate goals without becoming too dependent from China
will require alternate sources of rare earth minerals and batteries. To diversify
its sources, the EU launched the Global Gateway Initiative in 2021, a
iming to
improve economic ties with trade partners, especially those supplying essential
materials. How can Europe better implement the Critical Raw Materials Act of
2023
–
to get enough raw materials and thus cheap energy from different and
local sources?
Does green methanol, a low
-
carbon fuel produced from
renewable sources, offer a solution?
Can the private sector help pay for and
build reliable energy infrastructure?`,
                    moderators:[
                        new Moderator(`Bo Lidegaard`, `Co
                                                        -
                                                        Founder and Partner, Kaya Advisory; former
                                                        Editor Politiken
                                                        , Copenhagen`),
                    ],
                    speakers:[
                        new Speaker(`Cecilia Malmström`, `Senior Fellow (non
-
resident) at the Peterson Institute of
International Economics; f
ormer European Commissioner for Trade, European
Commission`),
                        new Speaker('Josu Jon Imaz', 'CEO, Repsol'),
                        new Speaker('Paolo Scaroni', `Chairman, Enel`),
                    ],
                    others:[
                        new Other('Scene Setter:', `<strong>Mia Kovačić</strong> Communications Director at CWP Global; <strong>DRF</strong>`)
                    ],
                },
                room: '',
            },
            {
                hours: '19:30',
                program: {
                    title: `<span style="font-weight: normal">Meet at the
Main
Hall
of the Rosewood Villa Magna Hotel</span>;
departure by bus to the Thyssen-Bornemisza National Museum`,
                    description: ``,
                    moderators:[

                    ],
                    speakers:[

                    ],
                }
            },{
                hours: '20:00 – 23:30',
                program: {
                    title: `Private Viewing, Cocktail and Gala Dinner <span style="font-weight: normal">(at the <a href="https://maps.app.goo.gl/v1v2vNG2RyP4fAiG6">Thyssen-Bornemisza National Museum</a>). Dinner will start at 21:00 and will end with a 30 minutes show.</span>`,
                    description: ``,
                    moderators:[

                    ],
                    speakers:[

                    ],
                }
            }
        ],[
            {
                hours: '09:00 – 10:00',
                program:{
                    title: `Panel 7:
North Africa and the Sahel
–
Factors for African and
European
S
ecurity`,
                    description: `The region will be shaped by major trends in the
two decades
, such as the
projected population growth
and
climate change that
will
put a lot of pressure
on the
se countries’
food and water resources
,
their
societ
ies, economies and
governments
.
External actors like China, Russia, the
United States
, the EU and
some Middle Eastern and Central Asian countries are increasingly involved in
North Africa and the Sahel and pursue different political, economic and
se
curity
-
related interests. Their presence and competition could increase the
potential for conflict, but also create more opportunities for cooperation in the
region.`,
                    moderators:[
                        new Moderator('Francesco Rocchetti', `Secretary General, Italian Institute for
                                                            International Pol
                                                            itical Studies (ISPI), Milan;
                                                            DRF`),
                    ],
                    speakers:[
                        new Speaker(`François Gouyette`, `former French Ambassador to the United Arab Emirates,
                                                            Libya, Tunisia, Saudi Arabia and Algeria`),
                        new Speaker(`Bernardino León`, `former
                                                        UN Special Representative in Libya, former EU
                                                        Special
                                                        Representative to the South Mediterranean, former Spanish Secretary
                                                        of State for Foreign Affairs`),
                                                        new Speaker(`Karim El Aynaoui
`, `Executive President of the Policy Center for the New South
;
Executive Vice
-
President of Mohammed VI Polytechnic University and Dean of
its H
umanities, Economics and Social Sciences Cluster
, Morocco`),
                        new Speaker(`Kamissa Camara`, `Professor of Practice in International Diplomacy, University
of Michigan; Senior Africa Advisor at the
US
Institute of Peace;
former
Minister of Foreign Affairs as well as Chief of
Staff to the President of Mali`),
                    ],
                },
                room: 'Level 1 - Belvédère',
            },
            {
                hours: '10:00 – 11:00',
                program:{
                    title: `Panel
8
:
Connecting With
Latin America`,
                    description: `Ironically, by securing itself with protectionist barriers, the United States is only
further ceding the ground to China, which has been a top provider of economic
develop
ment assistance in addition to top trader. With the United States
retreat from free trade and China’s economy slowing, Europe would be in an
advantageous position to expand and reinforce its trade relations and thus
influence capacity. However, success wil
l be conditioned on additional
economic outreach, especially liberal trade agreements and further
incorporation of the Global South into global decision
-
making.
In particular, t
he
EU should make further efforts to advance negotiations with the countries of
the
Southern Common Market (MERCOSUR)
.
A
global network of agreements
would become all the more important if the rules
-
based multilateral trading
system were to break down further.`,
                    moderators:[
                        new Moderator('Antonio Poncioni Merian', `Senior Advisor, Lazard Frères; Special
                            Envoy, Office of the President, Democratic Republic of Timor
                            -
                            Leste Advisor for
                            International Affairs, Office of the Prime Minister, Democratic Republic of São
                            Tomé e Príncipe;
                            <strong>DRF Alumni</strong>`),
                    ],
                    speakers:[
                        new Speaker('Susana Malcorra', `P
resident GWL Voices for Change and Inclusion
, former
Minister of Foreign Affairs, Argentina`),
                        new Speaker('José Antonio Álvarez', 'Vice President and former CEO of Santander Group'),
                        new Speaker('José Antonio García Belaúnde', `Chairman of Fundación Unión Europea
-
América Latina y Caribe;
f
ormer Minister of Foreign Affairs, Peru`),
                        new Speaker('Elaine Smith Genser', 'Trustee and Non - Executive Director, Anglo American Foundation; Head of Partnerships, United Nations Joint SDG Fund'),
                    ],
                },
                room: 'Groundfloor - Ballroom',
            },
            {
                hours: '11:00 – 11:30',
                program:{
                    title: `Coffee Break`,
                    description: ``,
                    moderators:[

                    ],
                    speakers:[

                    ],
                    others:[

                    ]
                },
                room: 'Groundfloor - Ballroom',
            },
            {
                hours: '11:30 – 12:00',
                program:{
                    title: `2
Parallel
Breakout Sessions <span style="font-weight: normal">(organized by
DRFs)</span>`,
                    description: `Breakout
Session 1
:
Neurotechnology: Opportunities and Neuro
-
rights
The brain is a very complicated organ with many types of cells and connections
that shape the human personality and consciousness. To understand how the
brain work
s, you first need to create a map of brain activity and then decode
the information it contains. Neurotechnology can measure and change not only
brain activity, but also the mental and cognitive activities that make up the
human condition. This requires th
e protection of brain activity as a fundamental
human right to ensure privacy, personal identity and free choice.
Neurotechnology can improve the lives of patients with neurological diseases
or damage by helping them communicate or move, or by boosting the
ir
cognitive abilities. But it can also be misused to influence or direct people's
thoughts or behavior, or to create an unequal society.`,
                    moderators:[
                        new Moderator('Levent Tuzun' ,`Principal Economist at the European Bank for
Reconstruction and Development (EBRD);
<strong>
DRF
Representative.</strong>`)
                    ],
                    speakers:[
                        new Speaker(`Rafael Yuste`, `Director
,
NeuroTechnology Centre at Columbia University
, NY`), 
                        new Speaker(`Jared Genser`, `Managing Director of Perseus Strategies`),
                    ],
                },
                room: 'Groundfloor - Corridor & Foyer',
            },
            {
                hours: '12:00 – 12:30',
                program:{
                    title: `Breakout
Session 2
:
Addressing Europe's Lag in Flexibility and Future Skills`,
                    description: `Automation will have far
-
reaching impacts on the labor market. It could create
millions of new jobs, but it could also eliminate millions of existing jobs. But the
European labor market is characterized by rigid rules that make it difficult for
workers to
change careers. Businesses are already suffering from a lack of
skilled tech workers, and this will only worsen unless Europe’s educational
systems improves their skills training. Europe has a shortage of science,
technology, engineering and mathematics (S
TEM) graduates, which are
important for automation. The EU is well behind globally, e.g. vis
-
a
-
vis the
United States, China, and South Korea. How can industries better cooperate
with educational institutions and policy makers on (re)skilling programs to
pr
epare people for new lines of work?
Moreover
, attracting talent will be key,
especially in cutting
-
edge fields such as AI. Should Europe’s decision makers
consider extending free trade to “free human capital movement agreements”
with other regions, or tax
incentives for immigrating as well as returning talent?`,
                    moderators:[
                        new Moderator('Nina Hälg', `Manager Public Sector, Deloitte Consulting AG, Zürich`),
                    ],
                    speakers:[
                        new Speaker(`
Davide Dattoli
,`, `Founder and Executive Chairman of Talent Garden`),
                        new Speaker('Alex Vanopslagh', `Member of the Folketing and
Leader of Liberal Alliance,
Denmark`),
                        new Speaker('Jason Blackstock', `Founder and CEO, How to Change the World`),
                    ],
                }
            },
            {
                hours: '12:30 – 13:45',
                program:{
                    title: `Closing Remarks by the Conference Chairmen`,
                    description: ``,

                },
                room: 'Groundfloor - Ballroom'
            },
            {
                hours: '12:45 – 14:00',
                program:{
                    title: `Closing Lunch`,
                    description: ``,
                    moderators: [],
                    speakers: [],
                },
                room: 'Groundfloor - Foyer',
            },
        ]
    ];

    return(
        <div className="dashboard">
            <Header back={true}></Header>
            <h2 className='mt-4 text-center'>
                Program
            </h2>
            <div className='grid-display mt-3'>
                <div className='grid-program'>
                {
                    dates.map((date, index)=>{
                        return(
                            <div key={index} className={"p-1 bg-light"} onClick={()=>{setDay(index)}}>
                                <div className={(index === day) ? 'card-date-active' : 'card-date'}>
                                    {date}
                                </div>
                            </div>
                        );
                        })
                    }
                </div>
            </div>
            <div className='container'>
                {
                    program[day].map((prog, index)=>{
                        const hours = prog.hours.split(' – ');
                        return(
                            <div key={index} className={(index % 2) ? 'p-1 program bg-l' : 'mt-3 program bg-d'}>
                                <div className='text-center p-2'>
                                    <h6 className='start-h'>
                                        {hours[0]}
                                    </h6>
                                    <h6 className='end-h'>
                                        {hours[1]}
                                    </h6>
                                </div>
                                <div className='p-2'>
                                    <span style={{fontWeight: 'bold', fontSize: '1.4em'}} dangerouslySetInnerHTML={{__html:prog.program.title}}></span>
                                    <br />                                    
                                    {
                                        (prog.program.description && prog.program.description.length) ?
                                        <div>
                                            <br />
                                            <span dangerouslySetInnerHTML={{__html: prog.program.description}}>
                                        </span>   
                                        </div>
                                        :
                                        ''
                                    }
                                    <br />
                                    {
                                        prog.program.others ?
                                        prog.program.others.map((other, index)=>{
                                            return (
                                            <div key={index}>
                                                <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: other.title}}></span>
                                                <span dangerouslySetInnerHTML={{__html:other.description}}></span>
                                                <br />
                                            </div>)
                                        })
                                        :
                                        ''
                                    }
                                    {(prog.program.moderators && prog.program.moderators.length) ? <><br /><span style={{fontWeight: 'bold', fontSize: '1.2em'}}>Moderator:</span><br /></> : ''}
                                    
                                    {
                                        prog.program.moderators && prog.program.moderators.map((mod, index)=>{
                                            return(
                                                <div key={index}>
                                                    <span style={{fontWeight: 'bold'}}>{mod.full_name}: </span>
                                                    <span dangerouslySetInnerHTML={{__html: mod.description}}></span>
                                                    <br />
                                                    <br />
                                                </div>
                                            );
                                        })
                                    }
                                    {
                                        prog.program.mores ?
                                        prog.program.mores.map((more, index)=>{
                                            return (
                                            <div key={index}>
                                                <span style={{fontWeight: 'bold'}}>{more.title}</span>
                                                <span dangerouslySetInnerHTML={{__html:more.description}}></span>
                                                <br />
                                                <br />
                                            </div>)
                                        })
                                        :
                                        ''
                                    }
                                    {(prog.program.speakers && prog.program.speakers.length) ? <><span style={{fontWeight: 'bold', fontSize: '1.2em'}}>{(prog.program.speakers.length > 1) ? 'Speakers:' : 'Speaker:'}</span></> : ''}
                                    {
                                        prog.program.speakers && prog.program.speakers.map((speaker, index)=>{
                                            return(
                                                <div key={index}>
                                                    <span style={{fontWeight: 'bold'}}>{speaker.full_name}: </span>
                                                    <span>{speaker.description}</span>
                                                    <br />
                                                    <br />
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            <FooterPartenerCommun/>
        </div>
    )
}

class Speaker{
    constructor(full_name, description){
        this.full_name = full_name;
        this.description = description;
    }
}

class Moderator{
    constructor(full_name, description){
        this.full_name = full_name;
        this.description = description;
    }
}

class Other {
    constructor(title, description){
        this.title = title;
        this.description = description;
    }
}